// extracted by mini-css-extract-plugin
module.exports = {"otpStatus":"OtpStatus_otpStatus__2I-0M","spinner":"OtpStatus_spinner__3_nE5","message":"OtpStatus_message__21mjD","error":"OtpStatus_error__3lt_d"};